import React from 'react';
import { Button, Card, Result } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/utils/pathRoutes';
import { useGetPhanHe } from '@/hooks/useGetPhanHe';
import { CONSTANTS } from '@/utils/constants';
import { toSafeHtml } from '@/utils/sanitizeHtml'
interface NoPermissionCardProps {
    onBackHome?: () => void;
    textBackHome?: string;
    textDetail?: string;
}

const normalizePath = (path: string) => {
    let value = path.split('?')[0].split('#')[0].toLowerCase();
    if (!value.endsWith('/')) value += '/';
    return value;
};

const isSameRoute = (current: string, target: string) => normalizePath(current) === normalizePath(target);

const getHomeRouteByPhanHe = (phanHe: string) => {
    if (phanHe === CONSTANTS.PHAN_HE.VAN_HOA) return ROUTES.VAN_HOA.DASHBOARD;
    if (phanHe === CONSTANTS.PHAN_HE.QUY_TRINH) return ROUTES.QUY_TRINH.DASHBOARD;
    return ROUTES.HOME;
};

/**
 * Thẻ hiển thị lỗi không có quyền truy cập (403) – dùng chung cho nhiều trang.
 */
const NoPermissionCard: React.FC<NoPermissionCardProps> = ({
    onBackHome, textBackHome, textDetail }) => {
    const { t } = useTranslation();
    const router = useRouter();
    const phanHe = useGetPhanHe();

    const handleBack = () => {
        if (onBackHome) {
            onBackHome();
            return;
        }
        const target = getHomeRouteByPhanHe(phanHe);
        if (isSameRoute(router.asPath, target)) return;
        void router.push(target);
    };

    return (
        <Card
            style={{
                height: 'calc(100vh - 100px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Result
                status="403"
                title={
                    textDetail ? (
                        <span dangerouslySetInnerHTML={toSafeHtml(textDetail)} />
                    ) : (
                        t('bsc.msg.khongcoquyentruycap', 'Bạn không có quyền truy cập vào trang này')
                    )
                }
                subTitle={textDetail ? '' : t('bsc.msg.lienhequantrivien', 'Vui lòng liên hệ quản trị viên để được cấp quyền.')}
                extra={
                    <Button type="primary" onClick={handleBack}>
                        {textBackHome ? textBackHome : t('bsc.btn.vetrangchu', 'Về trang chủ')}
                    </Button>
                }
            />
        </Card>
    );
};

export default NoPermissionCard;

